function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) {
        _get = Reflect.get;
    } else {
        _get = function get(target, property, receiver) {
            var base = _super_prop_base(target, property);
            if (!base) return;
            var desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.get) {
                return desc.get.call(receiver || target);
            }
            return desc.value;
        };
    }
    return _get(target, property, receiver || target);
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _super_prop_base(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = _get_prototype_of(object);
        if (object === null) break;
    }
    return object;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getAppAudiolangs, getAppSublangs, setProfileSettings } from "@common/actions";
import EditForm from "@common/components/EditForm";
import SettingItem from "@common/components/Settings/SettingItem";
import { changeWebSetting, convertLanguages } from "@common/utils/helpers";
import { Button, FormControl, InputLabel, MenuItem, Select, Spinner, Typography } from "@material-ui/core";
import { isEmpty, isEqual, isNil } from "lodash";
import React from "react";
import { connect } from "react-redux";
var langs = require("langs");
var availableLanguages = langs.all();
var AudioSubtitlesSettings = /*#__PURE__*/ function(SettingItem) {
    "use strict";
    _inherits(AudioSubtitlesSettings, SettingItem);
    var _super = _create_super(AudioSubtitlesSettings);
    function AudioSubtitlesSettings(props) {
        _class_call_check(this, AudioSubtitlesSettings);
        var _this;
        _this = _super.call(this, props);
        _define_property(_assert_this_initialized(_this), "closeForms", function() {
            var _this_props_profileSettings_web_settings = _this.props.profileSettings.web_settings, audio = _this_props_profileSettings_web_settings.audio, subtitles = _this_props_profileSettings_web_settings.subtitles;
            _this.setState({
                editting: {
                    audio: false,
                    subtitles: false
                },
                audio: audio,
                subtitles: subtitles
            });
        });
        var _this1 = _assert_this_initialized(_this);
        _define_property(_assert_this_initialized(_this), "save", /*#__PURE__*/ _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                _this1.closeForms();
                return [
                    2
                ];
            });
        }));
        _define_property(_assert_this_initialized(_this), "renderLeftButton", function() {
            var editting = _this.state.editting.audio || _this.state.editting.subtitles;
            if (!editting) {
                return undefined;
            }
            return /*#__PURE__*/ _jsxs(Button, {
                classes: {
                    label: "ux-button-label"
                },
                onClick: _this.closeForms,
                className: "go-back-button raised half-width",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "icon icon-keyboard-arrow-right"
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        children: _this.props.i18n.common.back
                    })
                ]
            });
        });
        var _this2 = _assert_this_initialized(_this);
        _define_property(_assert_this_initialized(_this), "getAvailableLanguages", /*#__PURE__*/ _async_to_generator(function() {
            var _this_props_appConfig, audio, subtitles, _tmp, _tmp1;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this_props_appConfig = _this2.props.appConfig, audio = _this_props_appConfig.audio, subtitles = _this_props_appConfig.subtitles;
                        _tmp = isEmpty(audio);
                        if (!_tmp) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            _this2.props.getAppAudiolangs()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        _state.label = 2;
                    case 2:
                        _tmp;
                        _tmp1 = isEmpty(subtitles);
                        if (!_tmp1) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            _this2.props.getAppSublangs()
                        ];
                    case 3:
                        _tmp1 = _state.sent();
                        _state.label = 4;
                    case 4:
                        _tmp1;
                        return [
                            2
                        ];
                }
            });
        }));
        _define_property(_assert_this_initialized(_this), "findLanguage", function(value) {
            var i18n = _this.props.i18n;
            if (isNil(value)) {
                return i18n.settings.defaultLang;
            }
            if (value === -1) {
                return i18n.player.subtitleOff;
            }
            var language = availableLanguages.find(function(element) {
                return element["2B"] === value;
            });
            return language ? language.local : i18n.settings.defaultLang;
        });
        _define_property(_assert_this_initialized(_this), "handleLanguageChange", function(type, value) {
            var _this_props = _this.props, onChangeHandler = _this_props.onChangeHandler, profileSettings = _this_props.profileSettings;
            _this.setState(_define_property({}, type, value), function() {
                var _this_state = _this.state, audio = _this_state.audio, subtitles = _this_state.subtitles;
                onChangeHandler && onChangeHandler(changeWebSetting(profileSettings, {
                    audio: audio,
                    subtitles: subtitles
                }));
            });
        });
        _define_property(_assert_this_initialized(_this), "renderEdit", function(values) {
            var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "audio";
            var i18n = _this.props.i18n;
            var currentValue = _this.state[type];
            var languages = _to_consumable_array(type === "subtitles" ? [
                -1
            ] : []).concat([
                null
            ], _to_consumable_array(convertLanguages(values))).map(function(value) {
                return /*#__PURE__*/ _jsx(MenuItem, {
                    value: value,
                    className: "ux-select-option",
                    classes: {
                        selected: "ux-select-option-selected"
                    },
                    children: _this.findLanguage(value)
                }, "menu-item-edit-".concat(value));
            });
            return /*#__PURE__*/ _jsx("div", {
                className: "item-wrapper",
                style: {
                    paddingLeft: 0
                },
                children: /*#__PURE__*/ _jsx(Select, {
                    value: currentValue,
                    onChange: function(event) {
                        return _this.handleLanguageChange(type, event.target.value);
                    },
                    label: i18n.settings.selectLanguage,
                    placeholder: i18n.settings.selectLanguage,
                    displayEmpty: true,
                    fullWidth: true,
                    name: "language",
                    className: "parental-control-select parental-control-title",
                    children: languages
                })
            });
        });
        _define_property(_assert_this_initialized(_this), "renderRead", function(value) {
            var language = _this.findLanguage(value);
            return /*#__PURE__*/ _jsx(Typography, {
                variant: "body1",
                style: {
                    fontSize: "1.4rem",
                    marginTop: -20
                },
                children: language
            });
        });
        var web_settings = _this.props.profileSettings.web_settings;
        _this.state = _object_spread_props(_object_spread({}, _this.state), {
            editting: {
                audio: false,
                subtitles: false
            },
            audio: web_settings.audio,
            subtitles: web_settings.subtitles,
            saving: false
        });
        return _this;
    }
    _create_class(AudioSubtitlesSettings, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.getAvailableLanguages();
                _get(_get_prototype_of(AudioSubtitlesSettings.prototype), "componentDidMount", this).call(this);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                _get(_get_prototype_of(AudioSubtitlesSettings.prototype), "componentDidUpdate", this).call(this, prevProps, prevState);
                if (!isEqual(this.props.profileSettings, prevProps.profileSettings)) {
                    var web_settings = this.props.profileSettings.web_settings;
                    var audio = web_settings.audio, subtitles = web_settings.subtitles;
                    this.setState({
                        audio: audio,
                        subtitles: subtitles
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_props = this.props, i18n = _this_props.i18n, appConfig = _this_props.appConfig;
                var audioMap = appConfig.audio, subtitlesMap = appConfig.subtitles;
                var _this_state = this.state, editting = _this_state.editting, audio = _this_state.audio, subtitles = _this_state.subtitles;
                return /*#__PURE__*/ _jsxs("div", {
                    className: "layout-2-columns",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "layout-column",
                            children: /*#__PURE__*/ _jsx(EditForm, {
                                title: i18n.settings.audioSettings,
                                onEditChange: function(audio) {
                                    return _this.setState({
                                        editting: _object_spread_props(_object_spread({}, editting), {
                                            audio: audio
                                        })
                                    });
                                },
                                editting: editting.audio,
                                iconClassName: "icon-2 isa_audio icon",
                                editView: this.renderEdit(audioMap, "audio"),
                                readView: this.renderRead(audio)
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "layout-column",
                            children: /*#__PURE__*/ _jsx(EditForm, {
                                title: i18n.settings.subSettings,
                                onEditChange: function(subtitles) {
                                    return _this.setState({
                                        editting: _object_spread_props(_object_spread({}, editting), {
                                            subtitles: subtitles
                                        })
                                    });
                                },
                                editting: editting.subtitles,
                                iconClassName: "icon-2 icon-settings-font-ic_subtiles icon",
                                editView: this.renderEdit(subtitlesMap, "subtitles"),
                                readView: this.renderRead(subtitles)
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return AudioSubtitlesSettings;
}(SettingItem);
var mapStateToProps = function(param) {
    var i18n = param.i18n, profileSettings = param.profileSettings, appConfig = param.appConfig;
    return {
        i18n: i18n,
        profileSettings: profileSettings,
        appConfig: appConfig
    };
};
export default connect(mapStateToProps, {
    getAppAudiolangs: getAppAudiolangs,
    getAppSublangs: getAppSublangs,
    setProfileSettings: setProfileSettings
})(AudioSubtitlesSettings);
